import React, { useCallback, useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { usePilotsValue } from '@bingads-webui-campaign-react/basic-context-utils';
import { NewSignupHeader } from '@bingads-webui-campaign-react/new-signup-header';
import { GlobalEventCallbackContext } from '@bingads-webui-campaign-react/global-event-callback-context';

export function GlobalMenu() {
  const serverContext = useContext(ServerContext);
  const { signOutCallback } = useContext(GlobalEventCallbackContext);
  const userName = serverContext.CurrentUser ?
    serverContext.CurrentUser.Name :
    serverContext.UserName;

  const {
    Urls: {
      SignOutUrl,
    } = {},
  } = serverContext;

  const isPMaxLiteCopilotLiveAgentEnabled = usePilotsValue('IsPMaxLiteCopilotLiveAgentEnabled');

  const onSupportButtonClick = useCallback(() => {
    if (isPMaxLiteCopilotLiveAgentEnabled) {
      document.dispatchEvent(new CustomEvent('copilotToggleEvent', {
        detail: {
          eventType: 'action',
          eventData: {
            ActionId: 'liveAgentSupport',
            FlowId: 'Copilot-Help-GetStarted-StartLiveChat',
          },
        },
      }));
    }
  }, [isPMaxLiteCopilotLiveAgentEnabled]);

  return (
    <NewSignupHeader
      userName={userName}
      signOutUrl={SignOutUrl}
      customizedSignOut={signOutCallback}
      showSupportButton={isPMaxLiteCopilotLiveAgentEnabled}
      onSupportButtonClick={onSupportButtonClick}
    />
  );
}
